import { Observable } from 'rxjs';
import { UploadService } from './upload.service';
import { FileStorageService } from './filestorage.service';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ProfilePhotoUploadService implements UploadService {
  constructor(private fileStorageService: FileStorageService) {}

  uploadFile(file: File): Observable<any> {
    return this.fileStorageService.uploadProfilePhoto(file);
  }
}
